module.exports = __webpack_public_path__ + "img/faq_2_img_3.0a221894.png";